import { Lead } from '../types'

// Helpers to generate timestamps at various points
const minutesAgo = (mins: number) =>
  new Date(Date.now() - mins * 60 * 1000).toISOString()

const hoursAgo = (hrs: number) =>
  new Date(Date.now() - hrs * 60 * 60 * 1000).toISOString()

const daysAgo = (days: number, hoursOffset = 0) =>
  new Date(
    Date.now() - (days * 24 + hoursOffset) * 60 * 60 * 1000,
  ).toISOString()

export const mockLeads: Lead[] = [
  // === TODAY — active pending ===
  {
    id: 'LD-1001',
    name: 'Sarah Jenkins',
    phone: '(555) 123-4567',
    email: 'sarah.j@example.com',
    source: 'Website',
    owner: 'Alex Rivera',
    status: 'New',
    timeEntered: minutesAgo(2),
    activities: [
      {
        id: 'a1',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(2),
      },
    ],
  },
  {
    id: 'LD-1002',
    name: 'Michael Chen',
    phone: '(555) 987-6543',
    email: 'mchen@domain.com',
    source: 'ICanBuy',
    owner: 'Unassigned',
    status: 'Contact Attempted',
    timeEntered: minutesAgo(8.5),
    activities: [
      {
        id: 'a2',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(8.5),
      },
      {
        id: 'a3',
        type: 'status_change',
        description: 'Status changed to Contact Attempted',
        timestamp: minutesAgo(4),
      },
    ],
  },
  {
    id: 'LD-1003',
    name: 'Emily Rodriguez',
    phone: '(555) 456-7890',
    email: 'emily.r@email.com',
    source: 'LendingTree',
    owner: 'Jessica Smith',
    status: 'Working',
    timeEntered: minutesAgo(5),
    activities: [
      {
        id: 'a4',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(5),
      },
      {
        id: 'a5',
        type: 'status_change',
        description: 'Status changed to Working',
        timestamp: minutesAgo(1),
      },
    ],
  },
  {
    id: 'LD-1004',
    name: 'David Thompson',
    phone: '(555) 222-3333',
    email: 'dthompson@work.com',
    source: 'Website',
    owner: 'Alex Rivera',
    status: 'New',
    timeEntered: minutesAgo(9.2),
    activities: [
      {
        id: 'a6',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(9.2),
      },
    ],
  },
  {
    id: 'LD-1005',
    name: 'Amanda Foster',
    phone: '(555) 444-5555',
    email: 'afoster@example.com',
    source: 'Zillow',
    owner: 'Marcus Johnson',
    status: 'Converted',
    timeEntered: minutesAgo(7),
    activities: [
      {
        id: 'a7',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(7),
      },
      {
        id: 'a8',
        type: 'status_change',
        description: 'Status changed to Converted',
        timestamp: minutesAgo(2),
      },
    ],
  },
  {
    id: 'LD-1006',
    name: 'Robert Wilson',
    phone: '(555) 777-8888',
    email: 'rwilson@domain.com',
    source: 'ICanBuy',
    owner: 'Jessica Smith',
    status: 'New',
    timeEntered: minutesAgo(0.5),
    activities: [
      {
        id: 'a9',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: minutesAgo(0.5),
      },
    ],
  },
  {
    id: 'LD-1007',
    name: 'Karen Mitchell',
    phone: '(555) 321-9876',
    email: 'kmitchell@email.com',
    source: 'Website',
    owner: 'Alex Rivera',
    status: 'New',
    timeEntered: hoursAgo(1.5),
    activities: [
      {
        id: 'a10',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: hoursAgo(1.5),
      },
    ],
  },
  {
    id: 'LD-1008',
    name: 'James Patterson',
    phone: '(555) 654-3210',
    email: 'jpatterson@work.com',
    source: 'Zillow',
    owner: 'Marcus Johnson',
    status: 'Nurturing',
    timeEntered: hoursAgo(3),
    activities: [
      {
        id: 'a11',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: hoursAgo(3),
      },
      {
        id: 'a12',
        type: 'status_change',
        description: 'Status changed to Nurturing',
        timestamp: hoursAgo(2.5),
      },
    ],
  },
  // === YESTERDAY ===
  {
    id: 'LD-1009',
    name: 'Lisa Nguyen',
    phone: '(555) 111-2222',
    email: 'lnguyen@example.com',
    source: 'LendingTree',
    owner: 'Jessica Smith',
    status: 'New',
    timeEntered: daysAgo(1, 3),
    activities: [
      {
        id: 'a13',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(1, 3),
      },
    ],
  },
  {
    id: 'LD-1010',
    name: 'Brian Cooper',
    phone: '(555) 333-4444',
    email: 'bcooper@domain.com',
    source: 'ICanBuy',
    owner: 'Alex Rivera',
    status: 'Contact Attempted',
    timeEntered: daysAgo(1, 6),
    activities: [
      {
        id: 'a14',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(1, 6),
      },
      {
        id: 'a15',
        type: 'status_change',
        description: 'Status changed to Contact Attempted',
        timestamp: daysAgo(1, 5),
      },
    ],
  },
  {
    id: 'LD-1011',
    name: 'Rachel Adams',
    phone: '(555) 555-6666',
    email: 'radams@email.com',
    source: 'Website',
    owner: 'Marcus Johnson',
    status: 'Working',
    timeEntered: daysAgo(1, 2),
    activities: [
      {
        id: 'a16',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(1, 2),
      },
      {
        id: 'a17',
        type: 'status_change',
        description: 'Status changed to Working',
        timestamp: daysAgo(1, 1),
      },
    ],
  },
  // === EARLIER THIS WEEK ===
  {
    id: 'LD-1012',
    name: 'Thomas Garcia',
    phone: '(555) 777-9999',
    email: 'tgarcia@work.com',
    source: 'Zillow',
    owner: 'Jessica Smith',
    status: 'New',
    timeEntered: daysAgo(3, 4),
    activities: [
      {
        id: 'a18',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(3, 4),
      },
    ],
  },
  {
    id: 'LD-1013',
    name: 'Stephanie Lee',
    phone: '(555) 888-0000',
    email: 'slee@example.com',
    source: 'LendingTree',
    owner: 'Alex Rivera',
    status: 'Converted',
    timeEntered: daysAgo(4, 5),
    activities: [
      {
        id: 'a19',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(4, 5),
      },
      {
        id: 'a20',
        type: 'status_change',
        description: 'Status changed to Converted',
        timestamp: daysAgo(4, 4),
      },
    ],
  },
  {
    id: 'LD-1014',
    name: 'Christopher Brown',
    phone: '(555) 222-1111',
    email: 'cbrown@domain.com',
    source: 'ICanBuy',
    owner: 'Unassigned',
    status: 'Contact Attempted',
    timeEntered: daysAgo(2, 7),
    activities: [
      {
        id: 'a21',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(2, 7),
      },
      {
        id: 'a22',
        type: 'status_change',
        description: 'Status changed to Contact Attempted',
        timestamp: daysAgo(2, 5),
      },
    ],
  },
  // === EARLIER THIS MONTH ===
  {
    id: 'LD-1015',
    name: 'Michelle Taylor',
    phone: '(555) 444-3333',
    email: 'mtaylor@email.com',
    source: 'Website',
    owner: 'Marcus Johnson',
    status: 'New',
    timeEntered: daysAgo(12, 2),
    activities: [
      {
        id: 'a23',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(12, 2),
      },
    ],
  },
  {
    id: 'LD-1016',
    name: 'Daniel Martinez',
    phone: '(555) 666-5555',
    email: 'dmartinez@work.com',
    source: 'Zillow',
    owner: 'Jessica Smith',
    status: 'Nurturing',
    timeEntered: daysAgo(15, 3),
    activities: [
      {
        id: 'a24',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(15, 3),
      },
      {
        id: 'a25',
        type: 'status_change',
        description: 'Status changed to Nurturing',
        timestamp: daysAgo(15, 1),
      },
    ],
  },
  {
    id: 'LD-1017',
    name: 'Jennifer White',
    phone: '(555) 999-8888',
    email: 'jwhite@example.com',
    source: 'LendingTree',
    owner: 'Alex Rivera',
    status: 'Contact Attempted',
    timeEntered: daysAgo(8, 6),
    activities: [
      {
        id: 'a26',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(8, 6),
      },
      {
        id: 'a27',
        type: 'status_change',
        description: 'Status changed to Contact Attempted',
        timestamp: daysAgo(8, 4),
      },
    ],
  },
  // === SENT TO FIVE9 — Today ===
  {
    id: 'LD-1018',
    name: 'Patricia Moore',
    phone: '(555) 101-2020',
    email: 'pmoore@example.com',
    source: 'Website',
    owner: 'Alex Rivera',
    status: 'Sent to Five9',
    timeEntered: hoursAgo(2),
    activities: [
      {
        id: 'a28',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: hoursAgo(2.2),
      },
      {
        id: 'a29',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: hoursAgo(2),
      },
    ],
  },
  {
    id: 'LD-1019',
    name: 'Kevin Harris',
    phone: '(555) 303-4040',
    email: 'kharris@domain.com',
    source: 'ICanBuy',
    owner: 'Jessica Smith',
    status: 'Sent to Five9',
    timeEntered: hoursAgo(4),
    activities: [
      {
        id: 'a30',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: hoursAgo(4.2),
      },
      {
        id: 'a31',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: hoursAgo(4),
      },
    ],
  },
  {
    id: 'LD-1020',
    name: 'Nancy Clark',
    phone: '(555) 505-6060',
    email: 'nclark@email.com',
    source: 'Zillow',
    owner: 'Marcus Johnson',
    status: 'Sent to Five9',
    timeEntered: hoursAgo(5.5),
    activities: [
      {
        id: 'a32',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: hoursAgo(5.7),
      },
      {
        id: 'a33',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: hoursAgo(5.5),
      },
    ],
  },
  // === SENT TO FIVE9 — Yesterday ===
  {
    id: 'LD-1021',
    name: 'George Lewis',
    phone: '(555) 707-8080',
    email: 'glewis@work.com',
    source: 'LendingTree',
    owner: 'Alex Rivera',
    status: 'Sent to Five9',
    timeEntered: daysAgo(1, 4),
    activities: [
      {
        id: 'a34',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(1, 4.2),
      },
      {
        id: 'a35',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: daysAgo(1, 4),
      },
    ],
  },
  {
    id: 'LD-1022',
    name: 'Sandra Walker',
    phone: '(555) 909-1010',
    email: 'swalker@example.com',
    source: 'Website',
    owner: 'Jessica Smith',
    status: 'Sent to Five9',
    timeEntered: daysAgo(1, 7),
    activities: [
      {
        id: 'a36',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(1, 7.2),
      },
      {
        id: 'a37',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: daysAgo(1, 7),
      },
    ],
  },
  // === SENT TO FIVE9 — Earlier this week ===
  {
    id: 'LD-1023',
    name: 'Mark Robinson',
    phone: '(555) 121-3131',
    email: 'mrobinson@domain.com',
    source: 'ICanBuy',
    owner: 'Marcus Johnson',
    status: 'Sent to Five9',
    timeEntered: daysAgo(3, 5),
    activities: [
      {
        id: 'a38',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(3, 5.2),
      },
      {
        id: 'a39',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: daysAgo(3, 5),
      },
    ],
  },
  // === SENT TO FIVE9 — Earlier this month ===
  {
    id: 'LD-1024',
    name: 'Laura King',
    phone: '(555) 141-5151',
    email: 'lking@email.com',
    source: 'Zillow',
    owner: 'Alex Rivera',
    status: 'Sent to Five9',
    timeEntered: daysAgo(10, 3),
    activities: [
      {
        id: 'a40',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(10, 3.2),
      },
      {
        id: 'a41',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: daysAgo(10, 3),
      },
    ],
  },
  {
    id: 'LD-1025',
    name: 'Paul Wright',
    phone: '(555) 161-7171',
    email: 'pwright@work.com',
    source: 'LendingTree',
    owner: 'Jessica Smith',
    status: 'Sent to Five9',
    timeEntered: daysAgo(14, 2),
    activities: [
      {
        id: 'a42',
        type: 'system',
        description: 'Lead entered pending queue',
        timestamp: daysAgo(14, 2.2),
      },
      {
        id: 'a43',
        type: 'system',
        description: 'Lead sent to Five9 dialer',
        timestamp: daysAgo(14, 2),
      },
    ],
  },
]
